import mailSync from '../../../../../../vendor/inbox/mailsync-form/src/Resources/js/mail-sync';

const initialize = () => {
    mailSync();
};
export default initialize;
